export default "__VITE_ASSET__D4hD16xv__"